import React, { useEffect, useMemo, useState } from 'react';
import Collapse from 'react-bootstrap/lib/Collapse';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';
import clsx from 'clsx';
import { loadStripe } from '@stripe/stripe-js';
import I18nRouter from '../I18nRouter';
import ButtonCertificate from '~/components/ButtonCertificate';
import IconArrowDown from '~/components/svg/icon-arrow-down.svg';
import config from '~/config';
import themeVariables from '~/shared/themeVariables';
import IconChecked from '~/components/svg/icon-checked.svg';
import IconBuyNow from '~/components/svg/icon-buy-now.svg';
import IconCrown from '~/components/svg/icon-crown.svg';
import IconClose from '~/components/svg/icon-x.svg';
import IconNextWhite from '~/components/svg/icon-next-white.svg';
import IconExtraLicense from '~/components/svg/illust-extra-license.svg';
import { makeSelectProfile } from '~/containers/AuthProvider/selectors';
import { buySingleLicense } from '~/containers/ExtraLicensePaymentModal/actions';
import { makeSelectPlanOfSingleLicense } from '~/containers/ExtraLicensePaymentModal/selectors';
import { locales } from '~/utils';
import { formatFloatNumber } from '~/utils/formatter';
import { makeSelectCardInfo } from '~/containers/PhotoPage/selectors';
import { UrlUtil } from '~/lib';
import Config from '~/config';

const roles = config.getRoles();

function ExtraLicense({
  t,
  lng,
  photo,
  profile,
  planOfSingleLicense,
  buySingleLicense,
  cardInfo,
}) {
  const [confirmInfo, setConfirmInfo] = useState({
    usage: null,
    destinationUrl: '',
    fullname: '',
  });
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showPayModal, setShowPayModal] = useState(false);
  const [openExtraLicenseForm, setOpenExtraLicenseForm] = useState(true);
  const [error, setError] = useState({
    selectUsage: false,
    fullname: false,
    destinationUrl: false,
  });
  const [stripe, setStripe] = useState(null);

  const optionSelect = useMemo(() => {
    return new Array(24).fill(1).map((_, index) => {
      return {
        value: t(`extra_license_usage_${index}`),
        label: t(`extra_license_usage_${index}`),
      };
    });
  }, [t]);
  const titleImage = useMemo(() => {
    if (!photo.title) return '';
    try {
      const objectTitle = JSON.parse(photo.title);

      const titleTmp =
        objectTitle[`title_${lng}`] ||
        objectTitle['title_en'] ||
        objectTitle['title_jp'] ||
        objectTitle['title_original'] ||
        '';
      // console.log(
      //   'vo day title khi khong co loi',
      //   titleTmp.length > 50 ? `${titleTmp.substring(0, 50)}...` : titleTmp,
      // );
      return titleTmp.length > 50
        ? `${titleTmp.substring(0, 50)}...`
        : titleTmp;
    } catch (error) {
      // console.error('Lỗi phân tích JSON:', error);
      return '';
    }
  }, [lng, photo.title]);

  useEffect(() => {
    (async function getStripe() {
      const stripe = await loadStripe(
        Config.stripePublicKey[Config.serviceType],
      );
      setStripe(stripe);
    })();
  }, []);

  const styleSelectPerPage = {
    container: (styles) => ({
      ...styles,
      width: '100%',
      borderRadius: 4,
      zIndex: 99999,
      height: 40,
      border: `1px solid ${!error.selectUsage ? '#7A7A7A' : '#FF0000'}`,
      color: '#000000',
      placeholder: {
        marginLeft: '8px',
      },
    }),
    control: (styles) => ({
      ...styles,
      border: 'none',
      height: '100%',
      width: '100%',
      color: '#000000',
    }),
    option: (provided, state) => ({
      ...provided,
      '&:hover': {
        backgroundColor: state.isSelected
          ? themeVariables.color.primary
          : config.isIllustAC()
          ? '#FBEBED'
          : '#c4c4c4',
        cursor: 'pointer',
      },
      backgroundColor: state.isSelected
        ? themeVariables.color.primary
        : 'white',
      zIndex: 99999,
    }),
    placeholder: (base) => ({
      ...base,
      marginLeft: '8px',
    }),
  };

  const premiumLink = '/premium';

  let priceText = '29.99USD';
  let licensePrice;
  if (planOfSingleLicense) {
    licensePrice = planOfSingleLicense.prices.find((item) => item.lang === lng);
    if (!licensePrice) {
      licensePrice = planOfSingleLicense.prices.find(
        (item) => item.lang === 'en',
      );
    }
    const price = formatFloatNumber(
      locales.roundPriceByCurrency(licensePrice.unit, licensePrice.price),
    );
    priceText = `${price}${licensePrice.unit}`;
  }

  const handleBuyExtraLicense = () => {
    if (
      profile.role === roles.GUEST ||
      profile.role === roles.FREE_MEMBER ||
      !profile.role
    ) {
      // For guest or free user, redirect to premium page
      return I18nRouter.push(premiumLink);
    }

    setShowConfirmModal(true);
  };

  const handleChangeInfo = (e) => {
    if (e.target) {
      const { name, value } = e.target;
      setConfirmInfo({ ...confirmInfo, [name]: value });
      if (name === 'fullname' && value) {
        setError({ ...error, fullname: false });
      }
    } else {
      setError({ ...error, selectUsage: false });
      setConfirmInfo({ ...confirmInfo, usage: e });
    }
  };

  const handleAddUserInfo = () => {
    const errorTmp = {
      selectUsage: false,
      fullname: false,
      destinationUrl: false,
    };

    if (!confirmInfo.usage) errorTmp.selectUsage = true;
    if (!confirmInfo.fullname) errorTmp.fullname = true;
    if (confirmInfo.destinationUrl) {
      const validUrl = UrlUtil.validURL(confirmInfo.destinationUrl);
      errorTmp.destinationUrl = !validUrl;
    }

    if (errorTmp.destinationUrl || errorTmp.selectUsage || error.fullname) {
      setError(errorTmp);
      return;
    }

    setShowConfirmModal(false);
    setShowPayModal(true);
  };

  const onPayNow = () => {
    console.log('stripe', stripe);
    // For premium user, proceed to buy extra license by payment card of premium subscription
    buySingleLicense({
      dataID: photo.id,
      currency: licensePrice.unit,
      lang: lng,
      packID: licensePrice.extra_license_pack_id,
      reason: confirmInfo.usage.value,
      destinationUrl: confirmInfo.destinationUrl,
      fullname: confirmInfo.fullname,
      stripe,
    });
    setShowPayModal(false);
    setConfirmInfo({
      usage: null,
      destinationUrl: '',
      fullname: '',
    });
  };

  const onHideModalConfirm = () => {
    setShowConfirmModal(false);
    setError({
      selectUsage: false,
      fullname: false,
      destinationUrl: false,
    });
  };

  return (
    <div>
      {config.isIllustAC() ? (
        <div className="container-license">
          <div className="content-license">
            <span className="icon-license">
              <IconExtraLicense />
            </span>
            <a href="/extra-license">{t('extra_license')}</a>
          </div>
        </div>
      ) : (
        <div className="container-license">
          <div
            className="content-license"
            onClick={() => setOpenExtraLicenseForm(!openExtraLicenseForm)}
          >
            <span className="icon-license">
              <IconCrown style={{ height: 16 }} />
            </span>
            {t('extra_license')}
          </div>
          <i className="icon-dropdown">
            <IconArrowDown
              style={{ height: 16 }}
              onClick={() => setOpenExtraLicenseForm(!openExtraLicenseForm)}
            />
          </i>
        </div>
      )}
      {!photo.current_user_extra_license ? (
        config.isIllustAC() ? (
          <div className="license-description">
            <h4>{t('action_buy_extra_license_text5')}</h4>
            <ul>
              <li>{t('action_buy_extra_license_text6')}</li>
              <li>{t('action_buy_extra_license_text7')}</li>
            </ul>
            <button className="btn-action-buy" onClick={handleBuyExtraLicense}>
              {t('buy_now')}
            </button>
          </div>
        ) : (
          <Collapse in={openExtraLicenseForm} className="data-collapse">
            <div>
              <p className="note">{t('action_buy_extra_license_text1')}</p>
              <div className="sub-content">
                <span className="icon-license">
                  <IconChecked style={{ height: 32 }} />
                </span>
                <div className="sub-content-text">
                  {t('action_buy_extra_license_text2')}
                </div>
              </div>
              <div className="sub-content">
                <span className="icon-license">
                  <IconChecked style={{ height: 32 }} />
                </span>
                <div className="sub-content-text">
                  {t('action_buy_extra_license_text3')}
                </div>
              </div>
              <div className="action-payment">
                <div className="price">
                  {t('price')}: {priceText}
                </div>
                <button className="action-buy" onClick={handleBuyExtraLicense}>
                  <span className="icon-buy-now">
                    <IconBuyNow style={{ height: 24, marginRight: 8 }} />
                  </span>
                  <div className="buy-now-text">{t('buy_now')}</div>
                </button>
              </div>
              <div className="sub-content-infor">
                <div
                  className="sub-content-infor-text"
                  dangerouslySetInnerHTML={{
                    __html:
                      profile.role === roles.PREMIUM
                        ? t('action_buy_extra_license_text4')
                        : t('subscribe_plan_to_buy_extra_license', {
                            premiumLink,
                          }),
                  }}
                ></div>
              </div>
            </div>
          </Collapse>
        )
      ) : (
        <Collapse in={openExtraLicenseForm} className="data-collapse">
          <div className="extra-license-add-checkbox">
            <span>{t('extra_license_bought_message')}</span>
            <ButtonCertificate
              className="btn-download-certificate"
              dataId={photo.id}
              logId={photo.current_user_extra_license.id}
            />
          </div>
        </Collapse>
      )}
      <Modal
        show={showConfirmModal}
        id="confirmModal"
        onHide={onHideModalConfirm}
        dialogClassName="confirm-modal-dialog"
        className="modal-confirm-wrapper"
      >
        <div className="modal-confirm-header">
          <span className="header-title">
            {t('extra_license_payment_confirm')}
          </span>
          <span className="icon-close" onClick={onHideModalConfirm}>
            <IconClose />
          </span>
        </div>
        <div className="modal-confirm-body">
          <div className="modal-confirm-image">
            <img
              alt="image download"
              className="image-download "
              src={photo.thumbnail}
            />
            <div className="image-id-wrapper">
              <span className="text-bold">
                {t(`${config.getPrefixContent('image_id')}`)}
              </span>
              : <span className="text-regular">{photo.id}</span>
            </div>
          </div>
          <div className="modal-confirm-info">
            <div className="user-info">
              <div className="user-info-content">
                <span className="text-bold">
                  {t('credit_premium_contact_email')}
                </span>
                <span className="text-regular">{profile.email}</span>
              </div>
            </div>
            <div
              className={clsx('user-info', {
                'user-info-required': error.fullname,
              })}
            >
              <div className="user-info-usage">
                <span>{t('extra_license_add_form_full_name')}</span>
                <span className="text-red"> {t('required_select')}</span>
              </div>
              <input
                type="text"
                name="fullname"
                value={confirmInfo.fullname}
                onChange={handleChangeInfo}
                placeholder={t('enter_fullname')}
                className={clsx('input-wrapper', {
                  'required-input-error': error.fullname,
                })}
              />
              {error.fullname && (
                <p className="usage-required-error">
                  *** {t('enter_fullname_required')}
                </p>
              )}
            </div>
            <div
              className={clsx('user-info', {
                'user-info-required': error.selectUsage,
              })}
            >
              <div className="user-info-usage">
                <span>{t('usage')}</span>
                <span className="text-red"> {t('required_select')}</span>
              </div>
              <Select
                options={optionSelect}
                onChange={handleChangeInfo}
                value={confirmInfo.usage}
                placeholder={t('select_one_option')}
                className="select-usage"
                styles={styleSelectPerPage}
              />
              {error.selectUsage && (
                <span className="usage-required-error">
                  *** {t('extra_license_select_required')}
                </span>
              )}
            </div>
            <div
              className={clsx('user-info', {
                'user-info-required': error.destinationUrl,
              })}
            >
              <p className="user-info-usage">
                {t('extra_license_destination_url')} ({t('optional')})
              </p>
              <input
                type="text"
                name="destinationUrl"
                value={confirmInfo.destinationUrl}
                onChange={handleChangeInfo}
                placeholder={t('enter_your_website')}
                className={clsx('input-wrapper', {
                  'required-input-error': error.destinationUrl,
                })}
              />
              {error.destinationUrl && (
                <p className="usage-required-error">
                  *** {t('invalid_url_message')}
                </p>
              )}
            </div>
            <div className="user-info">
              <div className="amount-info">
                <span>{t('amount')}</span>
                <span>{priceText}</span>
              </div>
            </div>
            <button onClick={handleAddUserInfo}>
              {t('next')}{' '}
              <span className="next-icon">
                <IconNextWhite />
              </span>
            </button>
          </div>
        </div>
      </Modal>

      <Modal
        show={showPayModal}
        onHide={() => setShowPayModal(false)}
        id="payModal"
        dialogClassName="modal-pay-confirm"
        className="modal-confirm-wrapper"
      >
        <div className="modal-confirm-header">
          <span className="header-title">
            {t('extra_license_payment_confirm')}
          </span>
          <span className="icon-close" onClick={() => setShowPayModal(false)}>
            <IconClose />
          </span>
        </div>
        <div className="modal-pay-body">
          <img
            alt="image download"
            className="image-download lazyload"
            src={photo.thumbnail}
          />
          <div className="image-payment-info">
            <div className="image-payment-item">
              <span className="text-bold">
                {t(`${config.getPrefixContent('image_id')}`)}
              </span>
              <span className="text-regular">{photo.id}</span>
            </div>
            <div className="image-payment-item">
              <span className="text-bold">{t('title')}</span>
              <span className="text-regular">{titleImage}</span>
            </div>
          </div>
          <div className="user-payment-info">
            <div className="user-payment-item">
              <span className="text-bold">{t('Name')}</span>
              <span className="text-regular">{confirmInfo.fullname}</span>
            </div>
            <div className="user-payment-item">
              <span className="text-bold">
                {t('credit_premium_contact_email')}
              </span>
              <span className="text-regular">{profile.email}</span>
            </div>
            <div className="user-payment-item">
              <span className="text-bold">{t('usage')}</span>
              <span className="text-regular">
                {confirmInfo.usage?.value || ''}
              </span>
            </div>
            <div className="user-payment-item">
              <span className="text-bold">
                {t('extra_license_destination_url')}
              </span>
              {confirmInfo.destinationUrl ? (
                <span className="text-regular">
                  {confirmInfo.destinationUrl}
                </span>
              ) : (
                <span className="text-regular no-answers">N/A</span>
              )}
            </div>
            <div className="user-payment-item">
              <span className="text-bold">{t('card_information')}</span>
              {cardInfo && (
                <div className="card-info text-regular">
                  <span>{cardInfo.last4}</span>
                  <span>{cardInfo.brand}</span>
                  <span>{`${cardInfo.exp_month}/${cardInfo.exp_year.slice(
                    -2,
                  )}`}</span>
                </div>
              )}
            </div>
          </div>
          <div className="user-payment-info total-amount">
            <span className="text-bold">{t('total_amount')}</span>
            <span className="text-regular">{priceText}</span>
          </div>
          <button className="pay-now-btn" onClick={onPayNow}>
            {t('credit_premium_benefit_button2')}
          </button>
          <div className="payment-privacy">
            <div className="payment-privacy-wrapper">
              <span className="">・</span>
              <span>{t('extra_license_policy')}</span>
            </div>
            <div className="payment-privacy-wrapper">
              <span className="">・</span>
              <span
                dangerouslySetInnerHTML={{
                  __html: t('extra_license_contact', {
                    linkExtraLicense: `${config.getSiteURL()}/extra-license`,
                    linkHelpPage: `${config.getSiteURL()}/help-page`,
                  }),
                }}
              />
            </div>
          </div>
        </div>
      </Modal>

      <style jsx>
        {`
          .data-collapse {
            width: 100%;
          }
          .container-license {
            display: flex;
            flex-direction: row;
            align-items: center;
            height: 48px;
            border-radius: 4px;
            margin-top: 16px;
            justify-content: space-between;
            ${config.isIllustAC() ? '' : 'padding: 0 8px;background:#ecf1f4;'}
          }
          .icon-license {
            margin-right: 8px;
          }
          .license-description,
          .license-description h4 {
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            color: #170507;
            margin: 0;
          }
          .btn-action-buy {
            border: 1px solid #7a7a7a;
            border-radius: 40px;
            padding: 6px 16px;
            font-weight: 700;
            font-size: 14px;
            line-height: 16px;
            background: #ffffff;
          }
          .btn-action-buy:hover {
            opacity: 0.8;
          }
          .content-license {
            display: flex;
            flex-direction: row;
            align-items: center;
            height: 100%;
            border-radius: 4px;
            font-weight: 700;
            width: 100%;
            height: 48px;
          }
          .note {
            font-weight: 500;
            font-size: 16px;
            line-height: 28px;
            color: #000000;
            margin-top: 4px;
          }

          .link-creator,
          .link-creator:hover {
            text-decoration-line: underline !important;
            opacity: 0.9;
            font-weight: 700;
          }
          .sub-content {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            margin-top: 4px;
            padding: 0 8px;
          }
          .sub-content-text {
            margin-left: 8px;
          }
          .sub-content-infor {
            margin-top: 8px;
          }
          .action-payment {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            margin-top: 16px;
            border: 2px solid #1b2833;
            border-radius: 4px;
            box-sizing: border-box;
          }
          .price,
          .action-buy {
            flex: 1;
            display: flex;
            justify-content: center;
            height: 44px;
            padding: 8px 0;
            align-items: center;
          }
          .price {
            background: #ffffff;
            font-style: normal;
            font-weight: bold;
            font-size: 16px;
            color: #1b2833;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
          }
          .action-buy {
            background: #1b2833;
            border: none;
            border-radius: 0;
            font-weight: bold;
            color: #f8f9fa;
            cursor: pointer;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
          }
          .action-buy:hover {
            background: ${themeVariables.colors.primary};
          }

          .modal-confirm-header {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            padding: 32px 32px 16px;
          }

          .modal-confirm-header .header-title {
            font-weight: 600;
            font-size: 20px;
            line-height: 23px;
            color: #000000;
          }

          .modal-confirm-image .image-id-wrapper {
            text-align: left;
            width: 100%;
            padding: 8px 0px;
            margin-top: 10px;
          }

          .modal-confirm-body {
            display: flex;
          }

          .modal-confirm-image {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            padding: 16px 32px 32px;
          }

          .image-download {
            width: 400px;
            height: 300px;
            background: #d9d9d9;
            border: 1px solid #7a7a7a;
            border-radius: 4px;
            margin-top: 10px;
          }

          .modal-confirm-info {
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            padding: 0 32px 32px;
            gap: 8px;
          }

          .modal-confirm-info button,
          .modal-pay-body button {
            padding: 4px 16px;
            width: 100%;
            height: 36px;
            border-radius: 4px;
            background: ${themeVariables.color.primary};
            outline: none;
            border-style: none;
            color: #ffffff;
          }

          .usage-required-error {
            font-weight: 400;
            font-size: 12px;
            line-height: 20px;
            color: #ff0000;
            position: absolute;
          }

          .modal-confirm-info button:hover,
          .modal-pay-body button:hover {
            opacity: 0.8;
          }

          .modal-confirm-info button .next-icon {
            width: 24px;
          }

          .user-info {
            width: 100%;
            text-align: left;
          }

          .user-info-required {
            height: 96px;
          }

          .user-info-content {
            padding: 8px 16px 8px 0px;
          }

          .text-bold {
            font-weight: 700;
            font-size: 16px;
            line-height: 28px;
            color: #170507;
          }

          .text-regular {
            font-weight: 500;
            font-size: 16px;
            line-height: 28px;
            color: #170507;
          }

          .user-info-content .text-bold {
            min-width: 100px;
            display: inline-block;
          }

          .user-info-usage {
            padding: 8px 0px;
            margin: 0;
          }

          .user-info input {
            border-radius: 4px;
            height: 40px;
            border: 1px solid #7a7a7a;
            padding: 6px 16px;
            width: 100%;
          }
          .amount-info {
            width: 100%;
            display: flex;
            border-top: 2px solid #000000;
            justify-content: space-between;
            align-items: flex-start;
            padding: 8px 0px;
            height: 44px;
          }

          .input-wrapper {
          }

          .icon-close {
            cursor: pointer;
            color: #333;
            transform: scale(0.8);
          }
          .icon-close:hover {
            opacity: 0.8;
          }

          .modal-pay-body {
            display: flex;
            flex-direction: column;
            align-items: center;
          }

          .image-payment-info {
            width: 409px;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            margin-top: 10px;
          }

          .user-payment-item {
            height: 44px;
            display: flex;
          }

          .image-payment-item {
            display: flex;
            justify-content: center;
          }

          .image-payment-item .text-bold,
          .user-payment-item .text-bold {
            min-width: 160px;
            display: inline-block;
          }

          .user-payment-info {
            border-top: 2px solid #170507;
            width: 409px;
            padding: 8px 16px 8px 0px;
            margin-top: 10px;
          }
          .total-amount {
            display: flex;
            justify-content: space-between;
            margin: 10px 0;
          }

          .pay-now-btn {
            width: 409px !important;
          }

          .payment-privacy {
            margin: 10px 0 32px;
            width: 409px;
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
          }

          .payment-privacy-wrapper {
            display: flex;
            justify-content: space-between;
          }

          .card-info {
            display: flex;
            width: 100%;
            justify-content: space-between;
          }

          .no-answers {
            color: #3a4ed7;
          }

          .required-input-error {
            border: 1px solid #ff0000 !important;
          }

          @media screen and (max-width: ${themeVariables.breakpoints.tabletL
              .maxWidth}px) {
            .modal-confirm-body {
              flex-direction: column;
            }
          }
          @media screen and (max-width: ${themeVariables.breakpoints.mobile
              .maxWidth}px) {
            .image-download {
              width: 300px;
              height: 200px;
            }

            .modal-confirm-image {
              padding: 8px 16px 16px;
            }

            .modal-confirm-info {
              padding: 0 16px 16px;
            }

            .image-payment-info,
            .user-payment-info,
            .pay-now-btn,
            .payment-privacy {
              width: 300px !important;
            }

            .text-bold,
            .text-regular {
              font-size: 14px;
            }

            .image-payment-item .text-bold,
            .user-payment-item .text-bold {
              min-width: 130px;
              display: inline-block;
            }

            .user-payment-info {
              padding: 8px 0;
            }
          }
        `}
      </style>
      <style jsx global>
        {`
          .modal-confirm-wrapper {
            overflow-y: scroll !important;
          }
          .confirm-modal-dialog {
            width: 878px;
            border-radius: 4px;
          }
          .modal-pay-confirm {
            width: 473px;
            border-radius: 4px;
            overflow: hidden;
          }
          .buy-now-text {
            color: #f8f9fa;
          }
          .premium-link {
            font-weight: 700;
          }
          .premium-link:hover {
            text-decoration: underline !important;
            opacity: 0.8;
          }

          @media screen and (max-width: ${themeVariables.breakpoints.tabletL
              .maxWidth}px) {
            .confirm-modal-dialog {
              width: 464px;
            }
          }

          @media screen and (max-width: ${themeVariables.breakpoints.mobile
              .maxWidth}px) {
            .modal-pay-confirm,
            .confirm-modal-dialog {
              width: 360px;
            }
          }
        `}
      </style>
    </div>
  );
}

const mapStateToProps = createStructuredSelector({
  profile: makeSelectProfile(),
  cardInfo: makeSelectCardInfo(),
  planOfSingleLicense: makeSelectPlanOfSingleLicense(),
});
const mapDispatchToProps = (dispatch) => ({
  buySingleLicense: (params) => dispatch(buySingleLicense(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ExtraLicense);
